// Cabanas data - photos served from /public/cabanas/<slug>/
// Cover image is always the first item of `images`.

export const CABANAS = [
  {
    id: "por-do-sol",
    name: "Cabana Pôr do Sol",
    slug: "porsol",
    price: 930,
    short:
      "Vista cinematográfica para o pôr do sol com a aconchegante essência rural.",
    description:
      "Uma fuga para casais e famílias que desejam viver o melhor da natureza ao entardecer. Com cama queen flutuante, hidromassagem e área gourmet com parrilla argentina exclusiva.",
    amenities: [
      "Área gourmet com parrilla argentina",
      "Chopeira exclusiva",
      "Hidromassagem",
      "Cama Queen flutuante",
      "Ar-condicionado split",
      "Wi-Fi",
      "Câmeras externas",
      "Pet friendly",
      "Redário",
      "Trilhas e fogueira",
    ],
    images: [
      "/cabanas/porsol/a11a8bbf-4622-489c-9585-d19b19f9466a.jpg",
      "/cabanas/porsol/6c17f81f-323a-4e0c-8706-c9e8188b6705.jpg",
      "/cabanas/porsol/d525863a-c561-4b51-bcd7-f5daf47c9a9e.jpg",
      "/cabanas/porsol/f16a2241-813a-4b6a-9b0b-80456d52b6a9.jpg",
      "/cabanas/porsol/397ddccc-b39a-4645-8e92-2ef802bd18a6.png",
      "/cabanas/porsol/413fa734-f6f5-40b0-8e38-cbcf13aca2cf.png",
    ],
  },
  {
    id: "domo-dos-sonhos",
    name: "Domo dos Sonhos",
    slug: "domo",
    price: 1120,
    short:
      "Glamping em estrutura geodésica com ofurô, banheira de spa e colheita de morangos.",
    description:
      "O refúgio mais imersivo da Quinta. Lareira interna, calefator, ofurô, banheira de spa externa e a experiência única de colher morangos no campo ao redor.",
    amenities: [
      "Área gourmet com parrilla argentina",
      "Chopeira exclusiva",
      "Banheira de spa externa",
      "Ofurô interno",
      "Lareira e calefator",
      "Colheita de morangos",
      "Cama Queen flutuante",
      "Ar-condicionado split",
      "Wi-Fi",
      "Pet friendly",
    ],
    images: [
      "/cabanas/domo/cabanasdaquinta_1775653279_3870782713544903050_68073555926.jpg",
      "/cabanas/domo/16277779-0ae2-467d-8e3a-efd3f75e4ecc.png",
      "/cabanas/domo/3efddf33-c49c-49d7-a363-10b15ea330f7.png",
      "/cabanas/domo/5a14c532-dfd1-4b70-9a3f-a1f2d7e51d8d.png",
      "/cabanas/domo/73405e97-3aa0-4fb8-9bda-8995452d90a9.png",
      "/cabanas/domo/d4fe600e-e558-4109-b87c-c4402113f182.png",
      "/cabanas/domo/doisgauchosviajando_1774534394_3861395729256725136_70239130154.jpg",
      "/cabanas/domo/f087fab6-bab5-44eb-824f-3384484097ae.png",
      "/cabanas/domo/fa8f8d3e-6f5f-4675-b95b-c7b73daf0076.png",
      "/cabanas/domo/paranaemfoto_1773665605_3854107437620402254_5896268406.jpg",
    ],
  },
  {
    id: "san-andreas",
    name: "Cabana San Andreas",
    slug: "sanandreas",
    price: 800,
    short:
      "Elegância orgânica e tranquilidade para quem busca silenciar a mente.",
    description:
      "Linhas modernas em meio à natureza, com hidromassagem privativa e o aconchego que só uma cabana de madeira pode oferecer.",
    amenities: [
      "Área gourmet com parrilla argentina",
      "Chopeira exclusiva",
      "Hidromassagem",
      "Cama Queen flutuante",
      "Ar-condicionado split",
      "Wi-Fi",
      "Pet friendly",
      "Redário",
      "Trilhas e fogueira",
    ],
    images: [
      "/cabanas/sanandreas/cabanasdaquinta_1768482023_3810625851918915228_68073555926.jpg",
      "/cabanas/sanandreas/cabanasdaquinta_1768482023_3810625852019588449_68073555926.jpg",
      "/cabanas/sanandreas/cabanasdaquinta_1768482023_3810625851113614515_68073555926.jpg",
      "/cabanas/sanandreas/cabanasdaquinta_1768482023_3810625851885364547_68073555926.jpg",
      "/cabanas/sanandreas/5910294b-8306-4d35-b341-72aaa24b31ad.png",
      "/cabanas/sanandreas/73fe4899-79f9-446a-8869-c9128105a463.png",
      "/cabanas/sanandreas/a597b6e1-509d-4ac9-bd6f-a0fa409138f5.png",
      "/cabanas/sanandreas/acd260c6-7879-421f-a6a0-53628fbd4c42.png",
      "/cabanas/sanandreas/ad4989e4-8b8f-4dd0-9010-f5bc62d56955.png",
      "/cabanas/sanandreas/b046a98a-3877-4f84-9a76-b59925012d9c.png",
    ],
  },
  {
    id: "diamante",
    name: "Cabana Diamante",
    slug: "diamante",
    price: 800,
    short:
      "Design sofisticado, materiais naturais e muita luz natural para o seu descanso.",
    description:
      "Uma joia de detalhes. Cama queen flutuante, hidromassagem e área gourmet preparada para receber bem, com a privacidade que você merece.",
    amenities: [
      "Área gourmet com parrilla argentina",
      "Chopeira exclusiva",
      "Hidromassagem",
      "Cama Queen flutuante",
      "Ar-condicionado split",
      "Wi-Fi",
      "Pet friendly",
      "Redário",
      "Trilhas e fogueira",
    ],
    images: [
      "/cabanas/diamante/7615b056-f4d5-4bcb-87fd-a5a04cdb4052.png",
      "/cabanas/diamante/7d96199d-484c-4542-8f1d-89169b7bce2b.png",
      "/cabanas/diamante/c7bb2608-dd73-49f1-ac33-a797e8524682.png",
      "/cabanas/diamante/dc739f83-49c4-4d3a-b50d-a9271ab2349a.png",
      "/cabanas/diamante/0c007347-d8aa-4818-9859-74767e8a8689.png",
      "/cabanas/diamante/64a1ee4c-9f44-416e-99a8-4598798f024b.png",
    ],
  },
  {
    id: "cristal",
    name: "Cabana Cristal",
    slug: "cristal",
    price: 800,
    short:
      "Transparência e integração perfeita com a floresta que abraça a cabana.",
    description:
      "Acorde com a luz do dia entrando pelas amplas janelas. Hidromassagem, parrilla argentina e a sensação constante de estar dentro da paisagem.",
    amenities: [
      "Área gourmet com parrilla argentina",
      "Chopeira exclusiva",
      "Hidromassagem",
      "Cama Queen flutuante",
      "Ar-condicionado split",
      "Wi-Fi",
      "Pet friendly",
      "Redário",
      "Trilhas e fogueira",
    ],
    images: [
      "/cabanas/cristal/cabanasdaquinta_1773234063_3850488862770801835_68073555926.jpg",
      "/cabanas/cristal/cabanasdaquinta_1773234063_3850488862275901803_68073555926.jpg",
      "/cabanas/cristal/cabanasdaquinta_1773234063_3850488862351423324_68073555926.jpg",
      "/cabanas/cristal/cabanasdaquinta_1773234064_3850488862309459128_68073555926.jpg",
      "/cabanas/cristal/045efa70-b136-4a83-b144-65c10c9e0dc8.png",
      "/cabanas/cristal/58527bde-b04d-4169-8856-2225b366ba78.png",
      "/cabanas/cristal/7ac3e3d1-7d76-4a6d-b54a-e5cc0252c51f.png",
      "/cabanas/cristal/aeb1edd3-83ac-4de7-bd92-67cdf2fe76fd.png",
      "/cabanas/cristal/e25317e5-5e10-4ae8-97b1-194d6aee7548.png",
      "/cabanas/cristal/ee8026ba-f2af-4429-9abc-85943f5ab469.png",
    ],
  },
  {
    id: "florida",
    name: "Cabana Flórida",
    slug: "florida",
    price: 800,
    short:
      "Um refúgio charmoso inspirado em chalés campestres, perfeito para descansar.",
    description:
      "Aconchego, paisagismo cuidadoso e a hospitalidade que faz da Cabanas da Quinta uma experiência única. Hidromassagem e área gourmet completa.",
    amenities: [
      "Área gourmet com parrilla argentina",
      "Chopeira exclusiva",
      "Hidromassagem",
      "Cama Queen flutuante",
      "Ar-condicionado split",
      "Wi-Fi",
      "Pet friendly",
      "Redário",
      "Trilhas e fogueira",
    ],
    images: [
      "/cabanas/florida/cabanasdaquinta_1773838816_3855561894958804186_68073555926.jpg",
      "/cabanas/florida/cabanasdaquinta_1773838816_3855561894606482366_68073555926.jpg",
      "/cabanas/florida/cabanasdaquinta_1773838816_3855561894858151304_68073555926.jpg",
      "/cabanas/florida/06d0603f-5e04-4c76-acb6-4cc6f4ba6f9a.png",
      "/cabanas/florida/2c3906fd-b202-46bc-ad47-da34ec4b7308.png",
      "/cabanas/florida/40704e0e-e9c2-42d9-9304-0c288ae6b8a4.png",
      "/cabanas/florida/aae72f25-97ce-4155-9f01-3631f21772a6.png",
      "/cabanas/florida/adb590cb-2792-4aa2-a521-adb5de6acf32.png",
      "/cabanas/florida/c8ba1e9f-90e5-47e3-8195-7093ccf08b36.png",
      "/cabanas/florida/cf33d7a8-d441-44e8-bb57-65c4cf7d651b.png",
    ],
  },
];

export const FAQ_ITEMS = [
  {
    q: "Posso levar meu pet?",
    a: "Sim! Somos pet friendly. Cobramos uma taxa adicional de R$ 200,00 para higienização especial após a hospedagem com animais de estimação.",
  },
  {
    q: "Tem alguma refeição inclusa?",
    a: "Sim! O café da manhã e o jantar estão inclusos no valor da diária, preparados com ingredientes locais e muito carinho.",
  },
  {
    q: "Onde fica localizado?",
    a: "Estamos em São José dos Pinhais (PR), em uma região rural cercada por natureza e plantações de morango, a cerca de 30 km da Capital Curitiba.",
  },
  {
    q: "Qual o horário de check-in?",
    a: "Check-in a partir das 12h00.",
  },
  {
    q: "Qual o horário de check-out?",
    a: "Check-out até as 17h00.",
  },
];

export const CONTACT = {
  business: "Cabanas da Quinta",
  address: "R. Alexandre Kreonis - Área Rural, São José dos Pinhais - PR, 83023-405",
  phone: "41 98540-7122",
  phoneIntl: "+5541985407122",
  email: "reservascabanasdaquinta@gmail.com",
  cnpj: "61.342.246/0001-36",
};

export const getCabanaById = (id) => CABANAS.find((c) => c.id === id);
